import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { ICFDIsZIPUploadInfo } from 'models/invoices.models'
import useDialog from 'hooks/Shared/useDialog'
import { IApiError } from 'services/Shared/shared.models'
import { ICFDIsZIPUploadInfoRequest } from 'services/Invoices/invoices.models'
import { getCFDIsZIPUploadInfo } from 'services/Invoices/invoices.services'

const useGetCFDIsZIPUploadInfo = ({
  workspaceId,
  jobId,
}: ICFDIsZIPUploadInfoRequest): UseQueryResult<
  ICFDIsZIPUploadInfo,
  IApiError
> => {
  const dialog = useDialog()

  const query = useQuery<ICFDIsZIPUploadInfo, IApiError>(
    ['get-invoices-zip-upload-info', workspaceId, jobId],
    () => {
      if (!workspaceId || !jobId)
        throw new Error(
          'Se necesita el id del espacio de trabajo y el id de la carga para obtener los detalles'
        )
      return getCFDIsZIPUploadInfo({ workspaceId, jobId })
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 20,
      cacheTime: 1000 * 60 * 20,
      onError: ({ message }) => {
        if (
          message ===
          'Se necesita el id del espacio de trabajo y el id de la carga para obtener los detalles'
        ) {
          dialog.danger({
            subtitle:
              'Se necesita el id del espacio de trabajo y el id de la carga para obtener los detalles.',
          })

          return
        }

        dialog.danger({
          subtitle: 'Hubo un error al obtener la información del zip',
          primaryButtonText: 'Reintentar',
          secondaryButtonText: 'Cancelar',
          onPrimaryClick: query.refetch,
        })
      },
    }
  )

  return query
}

export default useGetCFDIsZIPUploadInfo
